import React, { createContext, useContext, useState, useEffect } from 'react';

// إنشاء سياق اللغة
const LanguageContext = createContext();

// مزود سياق اللغة
export const LanguageProvider = ({ children }) => {
  // استخدام الحالة لتخزين اللغة الحالية
  const [language, setLanguage] = useState('ar'); // الافتراضي هو العربية
  const [translations, setTranslations] = useState({});

  // تحميل ملفات الترجمة عند تغيير اللغة
  useEffect(() => {
    if (!language) return; // حماية من undefined
    const loadTranslations = async () => {
      try {
        // المسار الصحيح بالنسبة لـ src/context/LanguageContext.js
        const translationFile = await import(`../../assets/locales/${language}.json`);
        setTranslations(translationFile.default || translationFile);
      } catch (error) {
        console.error('فشل في تحميل ملف الترجمة:', error);
        setTranslations({});
      }
    };
    loadTranslations();
  }, [language]);

  // تبديل اللغة
  const toggleLanguage = () => {
    setLanguage(prevLang => (prevLang === 'ar' ? 'en' : 'ar'));
  };

  // تغيير اللغة إلى لغة محددة
  const changeLanguage = (lang) => {
    if (lang === 'ar' || lang === 'en') {
      setLanguage(lang);
    }
  };

  // القيمة التي سيتم توفيرها للمكونات
  const value = {
    language,
    translations,
    toggleLanguage,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// هوك مخصص لاستخدام سياق اللغة
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('يجب استخدام useLanguage داخل LanguageProvider');
  }
  return context;
};